import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { DeskPool } from '../../DeskPool';
import { ShootingPlayer } from '../../../molecules/ShootingPlayer';
import { useAppDispatch } from '../../../../hooks';
import { resetShowShooters } from '../../../../store/match';
export function Shooting() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(resetShowShooters());
    }, [dispatch]);
    const onPlayerClickAction = null;
    const gameButtonState = null;
    const getShootingPlayerChoice = () => _jsx(ShootingPlayer, {});
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: getShootingPlayerChoice }));
}
